import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";
import { TypographyMuted } from "../typography/Muted";
import Loading from "./loading";

interface Props extends HTMLAttributes<HTMLDivElement> {
  message?: string;
}

function FullScreenLoading({ message, className, ...props }: Props) {
  return (
    <div
      {...props}
      className={cn(
        "h-screen w-full flex flex-col gap-y-6 justify-center items-center dark:bg-brand-gray-950",
        className
      )}
    >
      <Loading size="md" />
      {message && <TypographyMuted>{message}</TypographyMuted>}
    </div>
  );
}

export default FullScreenLoading;
